import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createTenantUsersAdministrationRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../layouts/route-layout.vue'),
      children: [
        {
          path: '',
          component: () => import('../views/tenant-users-view.vue'),
          meta: {
            keepAlive: true
          },
          name: routeDefinitions.administration.tenant.tenantUsers
        },
        {
          path: ':id',
          component: () => import('../layouts/tenant-user-layout.vue'),
          props: true,
          children: [
            {
              path: '',
              name: routeDefinitions.administration.tenant.tenantUser.general,
              component: () => import('../views/tenant-user-general-view.vue'),
              props: true
            },
            {
              path: 'database-access',
              name: routeDefinitions.administration.tenant.tenantUser
                .databaseAccess,
              component: () =>
                import('../views/tenant-user-database-access-view.vue'),
              props: true
            },
            {
              path: 'access-roles',
              component: () =>
                import('../layouts/tenant-user-access-roles-layout.vue'),
              props: true,
              children: [
                {
                  path: '',
                  name: routeDefinitions.administration.tenant.tenantUser
                    .accessRoles,
                  component: () =>
                    import('../views/tenant-user-access-roles-view.vue'),
                  props: true
                }
              ]
            },
            {
              path: 'danger-zone',
              name: routeDefinitions.administration.tenant.tenantUser
                .dangerZone,
              component: () =>
                import('../views/tenant-user-danger-zone-view.vue'),
              props: true
            }
          ]
        }
      ]
    }
  ]
}
